import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=0cc37af6"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=0cc37af6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc37af6')) {
      api.createRecord('0cc37af6', component.options)
    } else {
      api.reload('0cc37af6', component.options)
    }
    module.hot.accept("./ThankYou.vue?vue&type=template&id=0cc37af6", function () {
      api.rerender('0cc37af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ThankYou.vue"
export default component.exports